var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"pagination"},_vm._l((_vm.pages),function(page,index){return _c("paginator-page-button",{key:index,tag:"li",attrs:{"page":page,"current-number":_vm.activePage},on:{"activated":function($event){_vm.navigateToPage(page)}}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4361a3f6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/paginator/Paginator.vue
// module id = 6B2c
// module chunks = 1